import React from 'react';
import { Col, Container, Row, Form } from 'react-bootstrap';
import './Newsletter.css';

const Newsletter = () => {
    return (
        <div className="element-widget">
                <Container>
                    <Row>
                        <Col>
                            <h2 className="align-right">NEWSLETTER SIGNUP</h2>
                        </Col>
                        <Col>
                            <Form>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Control type="email" placeholder="name@example.com" />
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                </Container>
        </div>
    );
};

export default Newsletter;